let id = 10000

export function getNextId(): number {
  return ++id
}

export function getNextKey(): string {
  return getNextId().toFixed(0)
}
